<template>
  <div class="w-full">
    <div class="animate-pulse">
      <div class="mt-3 h-24 rounded-md bg-gray-200" />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

export default class UserCardsSkeleton extends Vue {}
</script>
